const ChangeThirdPartyPhoneResourceStatistics = () =>
  import('@/views/main/externalStatistics/changeThirdPartyPhoneResourceStatistics/ChangeThirdPartyPhoneResourceStatistics.vue')

export default {
  path: '/main/externalStatistics/changeThirdPartyPhoneResourceStatistics',
  name: 'ChangeThirdPartyPhoneResourceStatistics',
  component: ChangeThirdPartyPhoneResourceStatistics
}
